<template lang="pug">
  div
    .main
      .config-form-wrapper.row
        .config-form.col-md-6.col-lg-5.col-xl-4
          h2.title {{title}}
          br
          SmartForm(
            v-if="hasColumns"
            :formList="formList"
            :formLabelWidth=160
            :columns="columns"
            :values="formValues")
</template>

<script>
import { fetchList } from '@/utils/api'
import SmartForm from '@/components/SmartForm'
import { expire } from '@/utils/auth'

export default {
  name: 'change-password',
  components: {
    SmartForm
  },
  created () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.getData()
  },
  data () {
    return {
      hasColumns: false,
      title: '系统配置',
      buttonList: [{
        name: 'submit',
        label: '提交',
        type: 'primary',
        validate: true,
        func: (values) => {
          console.log(values)
        }
      }],
      formValues: {},
      formList: [],
      columns: {}
    }
  },
  methods: {
    getData () {
      fetchList({
        resource: 'sys/config'
      }).then(data => {
        if (data) {
          this.columns = data.columns
          this.formList = Object.keys(data.columns)
          this.formValues = data.data
          this.hasColumns = true
          this.formList.map(formItem => {
            const { relation } = this.columns[formItem]
            if (relation !== '') {
              this.columns[formItem].options = data.relation[relation]
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.config-form-wrapper
  margin: 40px
.config-form
  margin: 0 auto
  .title
    padding-left: 140px
</style>



// WEBPACK FOOTER //
// Config.vue?54fb6e5e